import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Report = lazy(() => import('@feature/report').then(m => ({ default: m.Report })));
const EdlReport = lazy(() => import('@feature/report/pages').then(m => ({ default: m.EdlReport })));
const AnalyticsPage = lazy(() => import('@feature/analytics').then(m => ({ default: m.AnalyticsPage })));
const StatsDashboard = lazy(() => import('@feature/analytics/components').then(m => ({ default: m.StatsDashboard })));
// const DemographicGraphs = lazy(() => import('@feature/analytics/pages').then(m => ({ default: m.DemographicGraphs })));

import { ROUTES } from '@shared/constants/routes.constants';

export const reportsRoutes: RouteObject[] = [
  {
    path: ROUTES.REPORTS.ROOT,
    element: <Report />,
  },
  {
    path: ROUTES.REPORTS.EDL,
    element: <EdlReport />,
  },
  {
    path: ROUTES.REPORTS.ANALYTICS,
    element: <AnalyticsPage />,
  },
  {
    path: ROUTES.REPORTS.DEMOGRAPHIC_GRAPHS,
    element: <StatsDashboard />,
  },
];
